import { scaleLinear, scaleLog, scalePow, scaleSymlog, } from "./patchedScales.js";
export function sqScaleToD3(scale) {
    switch (scale.tag) {
        case "linear":
            return scaleLinear();
        case "symlog":
            return scaleSymlog().constant(scale.constant);
        case "power":
            return scalePow().exponent(scale.exponent);
        case "log":
            return scaleLog();
        default:
            throw new Error(`Unknown scale: ${scale}`);
    }
}
//# sourceMappingURL=index.js.map